import { render, staticRenderFns } from "./afterrecords.vue?vue&type=template&id=24ad0f15&scoped=true&"
import script from "./afterrecords.vue?vue&type=script&lang=js&"
export * from "./afterrecords.vue?vue&type=script&lang=js&"
import style0 from "./afterrecords.vue?vue&type=style&index=0&id=24ad0f15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ad0f15",
  null
  
)

export default component.exports